<template>
  <div class="page__menu">
    <template v-if="$privilege(PRIVILEGES.haldusnet.adminMenu)">
      <b-tabs v-model="activeMenuTab" :key="activeMenuTab" class="tabs">
        <b-tab>
          <template #title>
            <div class="d-flex align-items-center">
              {{ $t("general_haldusnet") }}
            </div>
          </template>
          <b-nav pills vertical class="navigation">
            <template v-for="item in navItems">
              <template v-if="item.href !== undefined">
                <b-nav-item
                  v-if="checkPrivileges(item)"
                  :key="item.name"
                  :href="item.href"
                  class="navigation__item"
                  :active="isActiveRoute(item.name)"
                  :disabled="item.disabled"
                >
                  <Icon :name="item.icon" font-scale="1.5" />
                  <div class="navigation__item-count-container">
                    {{ $t(item.name) }}
                    <span
                      v-if="item.count && taskCount > 0"
                      class="navigation__item-count navigation__item-count--keep-all"
                      >{{ taskCount }}</span
                    >
                  </div>
                </b-nav-item>
              </template>
              <template v-else>
                <b-nav-item
                  v-if="checkPrivileges(item)"
                  class="navigation__item"
                  :key="item.name"
                  :to="{
                    name: item.name,
                    params: item.params ? item.params : '',
                  }"
                  :active="isActiveRoute(item.name)"
                  :disabled="item.disabled"
                >
                  <Icon :name="item.icon" font-scale="1.5" />
                  <span>{{ $t(item.displayName ?? item.name) }}</span>
                </b-nav-item>
              </template>
            </template>
          </b-nav>
        </b-tab>
        <b-tab>
          <template #title>
            <div class="d-flex align-items-center">
              {{ $t("admin_modules") }}
              <span
                v-if="taskCount > 0"
                class="navigation__item-count navigation__item-count--tab-count"
                >{{ taskCount }}</span
              >
            </div>
          </template>
          <b-nav pills vertical class="navigation">
            <template v-for="item in adminNavItems">
              <template v-if="item.href !== undefined">
                <b-nav-item
                  v-if="checkPrivileges(item)"
                  :key="item.name"
                  :href="item.href"
                  class="navigation__item"
                  :active="isActiveRoute(item.name)"
                >
                  <Icon :name="item.icon" font-scale="1.5" />
                  <div class="navigation__item-count-container">
                    {{ $t(item.name) }}
                    <span
                      v-if="item.count && taskCount > 0"
                      class="navigation__item-count navigation__item-count--keep-all"
                      >{{ taskCount }}</span
                    >
                  </div>
                </b-nav-item>
              </template>
              <template v-else>
                <b-nav-item
                  v-if="checkPrivileges(item)"
                  :key="item.name"
                  :href="item.href"
                  class="navigation__item"
                  :to="{
                    name: item.name,
                  }"
                  :active="isActiveRoute(item.name)"
                >
                  <Icon :name="item.icon" font-scale="1.5" />
                  <div class="navigation__item-count-container">
                    {{ $t(item.name) }}
                    <span
                      v-if="item.count && taskCount > 0"
                      class="navigation__item-count navigation__item-count--keep-all"
                      >{{ taskCount }}</span
                    >
                  </div>
                </b-nav-item>
              </template>
            </template>
          </b-nav>
        </b-tab>
      </b-tabs>
    </template>
    <template v-else>
      <b-nav pills vertical class="navigation tabs">
        <template v-for="item in navItems">
          <template v-if="item.href !== undefined">
            <b-nav-item
              v-if="checkPrivileges(item)"
              :key="item.name"
              :href="item.href"
              class="navigation__item"
              :disabled="item.disabled"
              :active="isActiveRoute(item.name)"
            >
              <Icon :name="item.icon" font-scale="1.5" />
              <span>{{ $t(item.displayName ?? item.name) }}</span>
            </b-nav-item>
          </template>
          <template v-else>
            <b-nav-item
              v-if="checkPrivileges(item)"
              :key="item.name"
              class="navigation__item"
              :to="{
                name: item.name,
                params: item.params ? item.params : '',
              }"
              :disabled="item.disabled"
              :active="isActiveRoute(item.name)"
            >
              <Icon :name="item.icon" font-scale="1.5" />
              <span>{{ $t(item.displayName ?? item.name) }}</span>
            </b-nav-item>
          </template>
        </template>
      </b-nav>
    </template>
    <template v-if="showAds">
      <div v-for="image in ad" :key="image.id" class="ads">
        <a :href="image.link" target="_blank">
          <!--        TODO:: change link ti env variables when goes live-->
          <b-img
            fluid
            :src="`https://api.haldusnet.ee/${image.file_path}/${image.file_name}`"
            :alt="image.file_name"
          />
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import Icon from "@/components/Icon/Icon";
import { ROUTE_NAMES, ROUTES } from "@/constants/routeConstants";
import { mapGetters } from "vuex";
import service from "@/services/advertisements";
import { PRIVILEGES, PERSON_TYPE } from "@/constants/privileges";
import routeMixin from "@/mixins/routeMixin";

export default {
  name: "NavigationList",
  mixins: [routeMixin],
  components: { Icon },
  props: {
    showAds: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      ad: [],
      activeMenuTab: 0,
    };
  },
  computed: {
    ...mapGetters({
      active_role: "user/active_role",
      activeCoop: "user/active_cooperative",
      taskCount: "system/taskCount",
    }),
    navItems() {
      return [
        {
          path: ROUTES.dashboard,
          name: ROUTE_NAMES.dashboard,
          icon: "dashboard",
          params: this.activeCoopInUrl(),
          // disabled: !this.$route.params.id,
          privileges: [PRIVILEGES.haldusnet.view],
        },
        {
          path: ROUTES.myApartment,
          name: ROUTE_NAMES.myApartment,
          icon: "apartment",
          params: this.activeCoopInUrl(),
          disabled: this.isViewDisabled,
          privileges: [PRIVILEGES.haldusnet.apartmentSingleView],
        },
        {
          path: ROUTES.contacts,
          name: ROUTE_NAMES.contacts,
          icon: "phone",
          params: this.activeCoopInUrl(),
          privileges: [PRIVILEGES.haldusnet.view],
          disabled: this.isViewDisabled,
        },
        {
          path: ROUTES.readings,
          name: ROUTE_NAMES.readings,
          icon: "readings",
          params: this.activeCoopInUrl(),
          disabled: this.isViewDisabled,
          privileges: [PRIVILEGES.haldusnet.measurers],
        },
        {
          path: ROUTES.entries,
          name: ROUTE_NAMES.entries,
          icon: "readings",
          params: this.activeCoopInUrl(),
          disabled: this.viewDisabled(),
          privileges: [PRIVILEGES.haldusnet.entries],
          personType: [PERSON_TYPE.kvatro, PERSON_TYPE.board],
        },
        {
          path: ROUTES.gauge,
          name: ROUTE_NAMES.gauge,
          icon: "mootur",
          params: this.activeCoopInUrl(),
          disabled: this.viewDisabled(),
          privileges: [PRIVILEGES.haldusnet.gauge],
        },
        {
          path: ROUTES.periods,
          name: ROUTE_NAMES.periods,
          icon: "periods",
          params: this.activeCoopInUrl(),
          disabled: this.viewDisabled(),
          privileges: [PRIVILEGES.haldusnet.periods],
        },
        {
          path: ROUTES.invoices,
          name: ROUTE_NAMES.invoices,
          displayName: "invoices",
          icon: "bills",
          params: this.activeCoopInUrl(),
          disabled: this.viewDisabled(),
          privileges: [PRIVILEGES.haldusnet.boardInvoice],
          personType: [PERSON_TYPE.board, PERSON_TYPE.kvatro],
        },
        {
          path: ROUTES.notifications,
          name: ROUTE_NAMES.notifications,
          icon: "notifications",
          params: this.activeCoopInUrl(),
          disabled: this.viewDisabled(),
          privileges: [PRIVILEGES.haldusnet.notification],
        },
        {
          path: ROUTES.forum,
          name: ROUTE_NAMES.forum,
          icon: "forum",
          params: this.activeCoopInUrl(),
          disabled: this.viewDisabled(),
          privileges: [PRIVILEGES.haldusnet.forumView],
        },
        {
          path: ROUTES.cooperative,
          name: ROUTE_NAMES.cooperative,
          icon: "haldus",
          params: this.activeCoopInUrl(),
          disabled: this.viewDisabled(),
          privileges: [PRIVILEGES.haldusnet.viewApartment],
          personType: [PERSON_TYPE.kvatro, PERSON_TYPE.board],
        },
        {
          path: ROUTES.bills,
          name: ROUTE_NAMES.bills,
          displayName: "invoices",
          icon: "bills",
          params: this.activeCoopInUrl(),
          disabled: this.viewDisabled(),
          privileges: [PRIVILEGES.haldusnet.boardInvoice],
          personType: [PERSON_TYPE.resident],
        },
        {
          path: ROUTES.documents,
          name: ROUTE_NAMES.documents,
          icon: "documents",
          params: this.activeCoopInUrl(),
          disabled: this.viewDisabled(),
          privileges: [PRIVILEGES.haldusnet.document],
        },
        {
          path: ROUTES.statistics,
          name: ROUTE_NAMES.statistics,
          icon: "statistics",
          disabled: this.viewDisabled(),
          params: this.activeCoopInUrl(),
          privileges: [
            PRIVILEGES.haldusnet.entries,
            PRIVILEGES.haldusnet.measurers,
          ],
        },
        {
          href: this.$root.link(ROUTES.task_order, this.activeCoopInUrl()),
          name: ROUTE_NAMES.taskOrder,
          icon: "wrench",
          params: this.activeCoopInUrl(),
          disabled: this.viewDisabled(),
          privileges: [PRIVILEGES.haldusnet.taskOrderingView],
        },
        {
          href: this.$root.link(ROUTES.task, this.activeCoopInUrl()),
          name: ROUTE_NAMES.task,
          icon: "wrench",
          params: this.activeCoopInUrl(),
          disabled: this.viewDisabled(),
          privileges: [PRIVILEGES.haldusnet.taskOrderingView],
        },
        {
          href: this.$root.link(ROUTES.maintenance, this.activeCoopInUrl()),
          name: ROUTE_NAMES.maintenance,
          icon: "broom",
          params: this.activeCoopInUrl(),
          disabled: this.viewDisabled(),
          privileges: [PRIVILEGES.haldusnet.maintenance],
        },
        {
          path: ROUTES.meetings,
          name: ROUTE_NAMES.meetings,
          icon: "meetings",
          params: this.activeCoopInUrl(),
          disabled: this.viewDisabled(),
          privileges: [PRIVILEGES.meeting.view],
        },
      ];
    },
    adminNavItems() {
      return [
        {
          path: ROUTES.county,
          name: ROUTE_NAMES.county,
          icon: "building",
          privileges: [PRIVILEGES.haldusnet.county],
        },
        {
          path: ROUTES.documentCatalogues,
          name: ROUTE_NAMES.documentCatalogues,
          icon: "folder-transparent",
          privileges: [PRIVILEGES.haldusnet.catalogues],
        },
        {
          path: ROUTES.roles,
          name: ROUTE_NAMES.roles,
          icon: "editRoles",
          privileges: [PRIVILEGES.haldusnet.roles],
        },
        {
          path: ROUTES.cooperatives,
          name: ROUTE_NAMES.cooperatives,
          icon: "haldus",
          privileges: [
            PRIVILEGES.haldusnet.adminMenu,
            PRIVILEGES.haldusnet.viewCooperative,
          ],
          privilegeCondition: "AND",
        },
        {
          path: ROUTES.emailNotification,
          name: ROUTE_NAMES.emailNotification,
          icon: "emailNotification",
          privileges: [
            PRIVILEGES.haldusnet.adminMenu,
            PRIVILEGES.haldusnet.kvatroNotification,
          ],
          privilegeCondition: "AND",
        },
        {
          path: ROUTES.users,
          name: ROUTE_NAMES.users,
          icon: "residentAndApartments",
          privileges: [PRIVILEGES.haldusnet.users],
        },
        /*
        {
          href: '/et/test',
          name: 'laravel test',
          icon: "residentAndApartments",
          privileges: [PRIVILEGES.haldusnet.users],
        },
        */
        {
          path: ROUTES.labels,
          name: ROUTE_NAMES.labels,
          icon: "translation",
          privileges: [PRIVILEGES.haldusnet.labels],
        },
        {
          href: this.$root.link(ROUTES.workTypes, {}),
          name: ROUTE_NAMES.workTypes,
          icon: "manage",
          privileges: [PRIVILEGES.haldusnet.taskWork],
        },
        {
          path: ROUTES.taskAcceptance,
          name: ROUTE_NAMES.taskAcceptance,
          icon: "task",
          privileges: [PRIVILEGES.haldusnet.taskWork],
          count: this.getTaskCount(),
        },
        {
          href: this.$root.link(ROUTES.alldeviceOjects, this.activeCoopInUrl()),
          name: ROUTE_NAMES.alldeviceOjects,
          icon: "building",
          params: this.activeCoopInUrl(),
          disabled: this.viewDisabled(),
          privileges: [PRIVILEGES.haldusnet.alldeviceOjects],
        },
      ];
    },
    isViewDisabled() {
      /*
      if (this.active_role.personType === "kvatro") {
        return !this.$route.params.id || !this.activeCoop?.id;
      }
      */
      return !this.activeCoop?.id;
      //return !this.$route.params.id;
    },
  },
  created() {
    this.getAdvertisements();
  },

  methods: {
    viewDisabled() {
      /*
      if (this.active_role.personType === "kvatro") {
        return !this.$route.params.id || !this.activeCoop?.id;
      }
      */
      //return !this.$route.params.id || !this.activeCoop?.id;
      return !this.activeCoop?.id;
    },
    isActiveRoute(name) {
      let isActive = false;
      if (name === this.$route.name) {
        isActive = true;
      } else if (name === this.$route.meta.parent) {
        isActive = true;
      }
      return isActive;
    },
    activeCoopInUrl() {
      return { id: this.activeCoop?.id ?? 0 };
    },
    async getTaskCount() {
      await this.$store.dispatch("system/getTaskCount");
    },
    async getAdvertisements() {
      this.ad = await service.getAdvertisements();
      this.ad = this.ad.filter((e) => e.published);
    },
    setActiveMenuTab() {
      this.activeMenuTab = 0;
      this.adminNavItems.forEach((x) => {
        if (this.isActiveRoute(x.name)) {
          this.activeMenuTab = 1;
        }
      });
    },
    checkPrivileges(item) {
      // check if personType matches
      if (item.personType) {
        if (!item.personType.includes(this.active_role.personType)) {
          return false;
        }
      }
      const privileges = [];
      item.privileges.forEach((x) => {
        privileges.push(this.$privilege(x));
      });
      // check if every privilege in array is true
      if (item.privilegeCondition === "AND") {
        return privileges.every((element) => element === true);
      }
      // check if atleast one privilege in array is true
      return privileges.some((element) => element === true);
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.setActiveMenuTab();
      },
    },
  },
};
</script>
